/*
 * Grid / list view toggle for the collection grid.
 *
 * Pairs with the segmented control rendered by snippets/facets.liquid under
 * snz_filter, matching the toggle on the Searchanise toolbar.
 */
(function () {
  var KEY = 'wc:collection-view';

  function read() {
    try {
      return localStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function apply(mode, persist) {
    var grid = document.getElementById('product-grid');
    var buttons = document.querySelectorAll('[data-snz-view]');
    if (!grid) return;

    var isList = mode === 'list';
    grid.classList.toggle('product-grid--list', isList);

    if (buttons && buttons.length) {
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed', String(buttons[i].dataset.snzView === mode));
      }
    }

    if (!persist) return;
    try {
      localStorage.setItem(KEY, mode);
    } catch (e) {}
  }

  window.initCollectionViewToggle = function() {
    var savedMode = read() === 'list' ? 'list' : 'grid';
    apply(savedMode, false);
  };

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-snz-view]');
    if (btn) {
      event.preventDefault();
      apply(btn.dataset.snzView, true);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initCollectionViewToggle);
  } else {
    window.initCollectionViewToggle();
  }
})();
